import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { MapPin, FolderLock, CalendarDays, Newspaper } from "lucide-react";
import { Link } from "react-router-dom";

export default function Dashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState({ agents: 0, docs: 0, holidays: 0, news: 0 });

  useEffect(() => {
    (async () => {
      try {
        const [a, d, h, n] = await Promise.all([
          api.get("/agents"), api.get("/documents"), api.get("/holidays"), api.get("/news"),
        ]);
        setStats({ agents: a.data.length, docs: d.data.length, holidays: h.data.length, news: n.data.length });
      } catch {}
    })();
  }, []);

  const cards = [
    { label: "Agent Locations", value: stats.agents, icon: MapPin, to: "/portal/agents" },
    { label: "Documents", value: stats.docs, icon: FolderLock, to: "/portal/documents" },
    { label: "Holidays", value: stats.holidays, icon: CalendarDays, to: "/portal/holidays" },
    { label: "News Items", value: stats.news, icon: Newspaper, to: "/portal/news" },
  ];

  return (
    <div className="space-y-8" data-testid="dashboard">
      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-[#DC2A1C] font-semibold mb-2">Dashboard</div>
        <h1 className="text-3xl font-black tracking-tight">Welcome back, {user?.name}.</h1>
        <p className="text-gray-500 mt-1 text-sm">Here's an overview of your portal activity.</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
        {cards.map((c) => (
          <Link to={c.to} key={c.label} className="bg-white border border-gray-200 rounded-lg p-6 hover:-translate-y-0.5 hover:shadow-md transition-all">
            <c.icon className="w-5 h-5 text-[#DC2A1C] mb-4" />
            <div className="text-3xl font-black">{c.value}</div>
            <div className="text-xs uppercase tracking-[0.15em] text-gray-500 mt-1">{c.label}</div>
          </Link>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-[#F8F9FA] border border-gray-200 rounded-lg p-6">
          <h3 className="font-semibold mb-2">Quick actions</h3>
          <ul className="space-y-2 text-sm">
            <li>→ <Link to="/portal/agents" className="text-[#DC2A1C] hover:underline">View agent map</Link></li>
            <li>→ <Link to="/portal/documents" className="text-[#DC2A1C] hover:underline">Search documents</Link></li>
            {user?.role === "admin" && <li>→ <Link to="/portal/news" className="text-[#DC2A1C] hover:underline">Post a news update</Link></li>}
          </ul>
        </div>
        <div className="bg-[#F8F9FA] border border-gray-200 rounded-lg p-6">
          <h3 className="font-semibold mb-2">Your role</h3>
          <p className="text-sm text-gray-600">You are signed in as <span className="font-semibold text-[#DC2A1C] uppercase tracking-wide">{user?.role}</span>. {user?.role === "admin" ? "You have full CRUD access across all modules." : "You have read-only access. Contact an admin for changes."}</p>
        </div>
      </div>
    </div>
  );
}
